import React from "react";
import {
  BreadcrumbGroup,
  Header,
  Link,
  ColumnLayout,
  Alert,
} from "@cloudscape-design/components";

interface Office {
  code: string;
  url: string;
}

interface CityPageProps {
  cityName: string;
  offices: Office[];
  feedbackAlias: string;
  feedbackFirstName: string;
}

const CityPage: React.FC<CityPageProps> = ({
  cityName,
  offices,
  feedbackAlias,
  feedbackFirstName,
}) => {
  return (
    <ColumnLayout columns={2}>
      <div>
        <BreadcrumbGroup
          items={[
            { text: "Amazon Coffee Shuffle", href: "/" },
            { text: cityName, href: `/${cityName.toLowerCase()}` },
          ]}
        />
        <Header variant="h1">{cityName}</Header>
        <p>
          Thank you for checking in! You can sign up to next month's {cityName}{" "}
          Coffee Shuffle events here:
        </p>
        <Alert statusIconAriaLabel="Info" header="Known issue">
          When clicking the links below for the first time, you may be
          redirected to an event list instead of an individual event. Please
          click the link again to get to the proper event.
        </Alert>
        {offices.map((office) => (
          <ul>
            <li>
              <Link href={office.url} variant="primary">
                {office.code}
              </Link>
            </li>
          </ul>
        ))}

        <p>
          For feedback on {cityName} Coffee Shuffle, please contact{" "}
          <Link href={`https://phonetool.amazon.com/users/${feedbackAlias}`}>
            {feedbackFirstName}
          </Link>
        </p>
      </div>
      <img src={"/cities/" + cityName.toLowerCase() + "/logo.png"} />
    </ColumnLayout>
  );
};

export default CityPage;
